import { CUBE } from '@/constants/object';
import * as THREE from 'three';
import { BaseObject, applyGeometryProperty, applyProperties } from './base';

export class Cube extends BaseObject {
  constructor() {
    super(
      new THREE.BoxGeometry(CUBE.WIDTH, CUBE.HEIGHT, CUBE.DEPTH),
      new THREE.MeshStandardMaterial({ color: CUBE.COLOR })
    );

    this.width = CUBE.WIDTH;
    this.depth = CUBE.DEPTH;
    this.height = CUBE.HEIGHT;

    this.getOutline();

    this.updateGeometry = () => {
      this.geometry.dispose();
      this.geometry = new THREE.BoxGeometry(this.width, this.height, this.depth);
      this.getOutline();
    };

    this.applyProperties = (properties) => {
      applyProperties(this, properties, false);
      const needsUpdate =
        applyGeometryProperty(this, properties.width, 'width', CUBE.MIN_DIMENSION) |
        applyGeometryProperty(this, properties.depth, 'depth', CUBE.MIN_DIMENSION) |
        applyGeometryProperty(this, properties.height, 'height', CUBE.MIN_DIMENSION);

      if (needsUpdate) this.updateGeometry();
    };
  }
}
